module.exports = __webpack_public_path__ + "c3b3f789a9e4e875af5e41444a4620d3.svg";